module.exports = __webpack_public_path__ + "img/rejected.0a1a15b8.svg";